import { defineStore } from 'pinia'
import config from "../config.js";
import { uuid } from 'vue-uuid';
import { elements } from 'chart.js';

const helpKeyClass = 'help-content';
const helpKeyClassReverse = 'help-content-reverse';
const helpGroupClass = 'help_group';
const startAdjust = 20;

export const useHelpStore = defineStore('help', {
    state: () => ({
        help_key:'',
        help:null,
        child_elements:[],
    }),
    actions: {
        getParentElement(elem) {
            let result = null;
            if (elem.getBoundingClientRect().height > 0) {
                result = elem;
            } else {
                result = this.getParentElement(elem.parentElement);
            }
            return result;
        },
        getElementsByLabel(elem,label) {
            let result = [];
            if (elem.children.length == 0) {
                if (elem.innerText == label) {
                    let parent = this.getParentElement(elem);
                    if (parent != null) {
                        result.push(parent);
                    }
                }
            } else {
                let childExists = false;
                for (let i=0;i<elem.children.length;i++) {
                    let result2 = this.getElementsByLabel(elem.children[i],label);
                    if (result2.length > 0) {
                        result.push(...result2);
                        childExists = true;
                        break;
                    }
                }
                if (childExists == false) {
                    if (elem.innerText == label) {
                        let parent = this.getParentElement(elem);
                        if (parent != null) {
                            result.push(parent);
                        }
                    }
                }
            }
            return result;
        },
        createHelpAction(parentElem = null) {
            if (this.help == null) {
                return;
            }
            parentElem = (parentElem != null ? parentElem : document.body);
            for (let i=0;i<this.help.help_actions.length;i++) {
                let elem = document.createElement('div');
                elem.classList.add(helpKeyClass);
                elem.classList.add(helpGroupClass);
                elem.innerHTML = this.help.help_actions[i].help_content;
                elem.style.zIndex = '1000';
                elem.style.position = 'fixed';
                let deleteButton = document.createElement('span');
                deleteButton.style.position = 'absolute';
                deleteButton.style.top = '-5px';
                deleteButton.style.right = '0px';
                deleteButton.style.cursor = 'pointer';
                deleteButton.setAttribute('onclick',"this.parentNode.remove();return false;");
                let deleteMark = document.createElement('i');
                deleteMark.classList.add('fa-regular');
                deleteMark.classList.add('fa-circle-xmark');
                deleteButton.appendChild(deleteMark);
                elem.appendChild(deleteButton);
                let parents = [];
                if (this.help.help_actions[i].action_key_type == config.HELP_ACTION_KEY_TYPES['ラベル']) {
                    parents = this.getElementsByLabel(parentElem,this.help.help_actions[i].action_key);
                } else if (this.help.help_actions[i].action_key_type == config.HELP_ACTION_KEY_TYPES['クラス']) {
                    parents = parentElem.getElementsByClassName(this.help.help_actions[i].action_key);
                } else if (this.help.help_actions[i].action_key_type == config.HELP_ACTION_KEY_TYPES['ID']) {
                    let parent = parentElem.getElementById(this.help.help_actions[i].action_key);
                    if (parent != null) {
                        parents.push(parent);
                    }
                }
                for (let j=0;j<parents.length;j++) {
                    let child = elem.cloneNode(true);
                    let uuidClass1 = uuid.v1();
                    let uuidClass2 = uuid.v1();
                    if (parents[j].classList.contains(uuidClass1) == false) {
                        parents[j].classList.add(uuidClass1);
                    }
                    child.classList.add(uuidClass2);
                    let rect = parents[j].getBoundingClientRect();
                    this.setPosition(child,rect);
                    document.body.appendChild(child);
                    this.child_elements.push({
                        parent:uuidClass1,
                        child:uuidClass2
                    });
                }
            }
        },
        async fetchHelp(parentElem) {
            try {
                //loading を true に
                this.loading = true
                await fetch((<HTMLInputElement>document.getElementById('help_apis_help_list')).value + '?help_key=' + this.help_key)
                .then((response) => response.json())
                .then((data) => {
                    if (data.list.length > 0) {
                        this.help = data.list[0];
                    }
                    this.createHelpAction(parentElem);
                });
            } catch (error) {
                //エラースキップ
            } finally {
                //終了処理
            }
        },
        recoverHelp() {
            if (this.help_key.length > 0) {
                this.showHelp(document.body,this.help_key);
            }
        },
        showHelp(parentElem,helpKey) {
            if (this.help_key.length > 0) {
                //既に開いている場合は一旦削除
                this.closeHelp();
            }
            this.help_key = helpKey;
            this.fetchHelp(parentElem);
        },
        closeHelp() {
            for (let i=0;i<this.child_elements.length;i++) {
                let parents = document.getElementsByClassName(this.child_elements[i].parent_class_name);
                for (let j=0;j<parents.length;j++) {
                    parents[j].classList.remove(this.child_elements[i].parent_class_name);
                }
            }
            let helps = document.getElementsByClassName(helpGroupClass);
            for (let i=helps.length-1;i>=0;i--) {
                document.body.removeChild(helps[i]);
            }
            this.help = null;
            this.help_key = '';
            this.child_elements = [];
        },
        helpExists() {
            return (this.help_key.length > 0 ? true : false);
        },
        setPosition(elem,rect) {
            if ((window.innerWidth - 100) < rect.left) {
                //左向きを表示
                if (elem.classList.contains(helpKeyClassReverse) == false) {
                    elem.classList.add(helpKeyClassReverse);
                }
                elem.style.top = String(rect.top + rect.height + startAdjust) + 'px'; //被るとボタンの反応が悪くなるので余白分増やす
                elem.style.left = String(rect.right - 200 - 10) + 'px';
            } else { //右向きを表示
                if (elem.classList.contains(helpKeyClass) == false) {
                    elem.classList.add(helpKeyClass);
                }
                elem.style.top = String(rect.top + rect.height + startAdjust) + 'px'; //被るとボタンの反応が悪くなるので余白分増やす
                elem.style.left = String(rect.left) + 'px';
            }
        },
        helpResize() {
            for (let i=0;i<this.child_elements.length;i++) {
                let elem = document.getElementsByClassName(this.child_elements[i].child)[0];
                if (elem != null) {
                    let parent = document.getElementsByClassName(this.child_elements[i].parent)[0];
                    if (parent != null) {
                        let rect = parent.getBoundingClientRect();
                        this.setPosition(elem,rect)
                    }
                }
            }
        }
    },
    persist: true,
})
